// default font
import '@fontsource/karla/400.css';
import '@fontsource/karla/700.css';

// additional fonts based on options
import '@fontsource/alegreya-sans/400.css';
import '@fontsource/alegreya-sans/700.css';
import '@fontsource/work-sans/400.css';
import '@fontsource/work-sans/700.css';
import '@fontsource/archivo/400.css';
import '@fontsource/archivo/700.css';
import '@fontsource/rubik/400.css';
import '@fontsource/rubik/700.css';
import '@fontsource/arvo/400.css';
import '@fontsource/arvo/700.css';
import '@fontsource/martel-sans/400.css';
import '@fontsource/martel-sans/700.css';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/700.css';

// module imports
require("./partials/header.js");
require("./IE11.js");
require("./a11y.js");
require("./modules/menu.js");
require("./modules/switch.js");
require("./modules/gallery.js");
require("./modules/list-faq.js");
require("./modules/contentToggle.js");
require("./components/OrganizationArchive");
require("./components/OrganizationAddressMap");
require("./components/BulletboardArchive");
require("./components/BulletboardCreateItemWrapper");
